// @flow
export const moveCenterMap = (lat:number, lng:number, map:GoogleMap):void => {
  map.setCenter({lat, lng})
}